import { v4 } from 'uuid';

export class UUID extends String {
    constructor() {
        super(`SE-${v4()}`);
    }
}
